import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'redux/reduxHooks';
import { pushStep, STEPS, updateIsDone } from 'redux/bookingFormSlice';

const { PAYMENT } = STEPS;

/**
 * Routes the tail of the booking flow to the payment step (when a deposit
 * `clientSecret` exists) or to done. Callers that just received a fresh
 * create-booking response — whose Redux `clientSecret` is still stale this
 * render — should pass it via `overrideClientSecret`.
 */
export const useStep3Navigation = () => {
  const dispatch = useAppDispatch();
  const {
    bookingFormSlice: {
      step3: { clientSecret },
    },
  } = useAppSelector((state) => state);

  const routeAfterStep = useCallback(
    (currentStep: string, overrideClientSecret?: string) => {
      const secret = overrideClientSecret ?? clientSecret;

      if (secret) {
        dispatch(pushStep(PAYMENT));
        return;
      }

      dispatch(updateIsDone());
    },
    [clientSecret, dispatch]
  );

  return { routeAfterStep };
};
